import React, { useEffect, useState, useContext, useCallback } from "react";

// #region Components
import Input from "shared/components/FormElements/Input";
import CustomSelect from "shared/components/FormElements/Select";
import DatePicker from "shared/components/FormElements/DatePicker";
import Button from "shared/components/FormElements/Button";
import Card from "shared/components/UIElements/Card";
import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";
import ErrorModal from "shared/components/UIElements/ErrorModal";
import Modal from "shared/components/UIElements/Modal";
// #endregion Components

// #region Utils
import { VALIDATOR_REQUIRE, VALIDATOR_NONE } from "shared/util/validators";
import { isOfficial } from "shared/util/types";
// #endregion Utils

// #region Hooks
import { useForm } from "shared/hooks/form-hook";
import { useHttpClient } from "shared/hooks/http-hook";
import { AuthContext } from "shared/context/auth-context";
import { StoreContext } from "shared/context/store-context";
// #endregion Hooks

import "./AccountingItem.css";

const VehiclePaymentItem = (props) => {
  const auth = useContext(AuthContext);
  const store = useContext(StoreContext);

  const [itemstate, setItemState] = useState();
  const [loadedItem, setLoadedItem] = useState();

  const itemId = props.itemid;
  const updateStoreItems = store.UpdateVehiclePayments;

  const ItemTypeTR = "Araç Bilgileri";
  const ItemType = "vehiclePayment";
  const ItemEndPointType = "vehiclepayments";

  // #region Standard Interface functions
  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const showDeleteWarningHandler = () => {
    setShowConfirmModal(true);
  };

  const cancelDeleteHandler = () => {
    setShowConfirmModal(false);
  };
  // #endregion Standard Interface functions

  // #region Standard API calls
  const fetchItem = useCallback(async () => {
    try {
      const responseData = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/${ItemEndPointType}/${itemId}`);
      setLoadedItem(responseData[ItemType]);
      setItemState(Date.now().toString());
    } catch (err) {}
  }, [sendRequest, itemId]);

  const confirmDeleteHandler = async () => {
    setShowConfirmModal(false);
    try {
      await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/${ItemEndPointType}/${itemId}`, "DELETE", null, {
        "Content-Type": "application/json",
      });
      setItemState(Date.now());
      updateStoreItems();
      setLoadedItem(null);
      //   history.push(`/${ItemEndPointType}`);
    } catch (err) {}
  };
  // #endregion Standard API calls

  useEffect(() => {
    fetchItem();
  }, [itemId, fetchItem]);

  const [formState, inputHandler] = useForm(
    {
      school: { value: null, isValid: true },
      vehicleRoute: { value: "", isValid: true },
      plate: { value: "", isValid: true },
      owner: { value: "", isValid: true },
      driver: { value: "", isValid: true },
      district: { value: "", isValid: true },
      startDate: { value: "", isValid: true },
      endingDate: { value: "", isValid: true },
      hours: { value: "", isValid: true },
      hostess: { value: false, isValid: true },
      weekend: { value: false, isValid: true },
      description: { value: "", isValid: true },
      amount: { value: 0, isValid: true },
    },
    true
  );

  const itemUpdateSubmitHandler = useCallback(
    async (event) => {
      event.preventDefault();
      let responseData;
      try {
        responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/${ItemEndPointType}/${itemId}`,
          "PATCH",
          JSON.stringify({
            school: formState.inputs.school.value,
            vehicleRoute: formState.inputs.vehicleRoute.value,
            plate: formState.inputs.plate.value,
            owner: formState.inputs.owner.value,
            driver: formState.inputs.driver.value,
            district: formState.inputs.district.value,
            startDate: formState.inputs.startDate.value,
            endingDate: formState.inputs.endingDate.value,
            hours: formState.inputs.hours.value,
            hostess: formState.inputs.hostess.value,
            weekend: formState.inputs.weekend.value,
            description: formState.inputs.description.value,
            amount: formState.inputs.amount.value,
          }),
          {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          }
        );

        setLoadedItem(responseData[ItemType]);
        setItemState(Date.now());
        store.UpdateAccountingUtils();

        // history.push(`/${ItemEndPointType}`);
      } catch (err) {}
    },
    [auth.token, formState, sendRequest, itemId, ItemEndPointType, store]
  );

  if (isLoading) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!loadedItem && !error) {
    return (
      <div className="center">
        <Card>
          <h2>{ItemTypeTR} bulunamadı.</h2>
        </Card>
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <Modal
        show={showConfirmModal}
        onCancel={cancelDeleteHandler}
        header="Emin misiniz?"
        footerClass="place-item__modal-actions"
        footer={
          <React.Fragment>
            <Button inverse onClick={cancelDeleteHandler}>
              Hayır
            </Button>
            <Button danger onClick={confirmDeleteHandler}>
              Evet
            </Button>
          </React.Fragment>
        }
      >
        <p>{ItemTypeTR} silme işlemini onaylıyor musunuz? Bu işlem geri alınamaz.</p>
      </Modal>

      {!isLoading && loadedItem && (
        <form key={itemstate} className="item-form" onSubmit={itemUpdateSubmitHandler}>
          <div className="button-container">
            <Button type="button" danger onClick={props.onClose}>
              &#60; Geri
            </Button>
          </div>

          <CustomSelect
            options={store.schoolOptions}
            id="school"
            onInput={inputHandler}
            label="Okul"
            initialValid={true}
            initialValue={store.schoolOptions.find((item) => item.value.toString() === loadedItem.school.toString())}
          ></CustomSelect>

          <CustomSelect
            options={store.vehicleRouteOptions}
            id="vehicleRoute"
            onInput={inputHandler}
            label="Servis"
            initialValid={true}
            initialValue={store.vehicleRouteOptions.find(
              (item) => item.value.toString() === loadedItem.vehicleRoute.toString()
            )}
          ></CustomSelect>

          <Input
            id="plate"
            element="input"
            type="text"
            label="Plaka"
            validators={[VALIDATOR_NONE()]}
            errorText="Plaka giriniz."
            initialValue={loadedItem.plate}
            initialValid={true}
            onInput={inputHandler}
          />

          <Input
            id="owner"
            element="input"
            type="text"
            label="Araç sahibi"
            validators={[VALIDATOR_REQUIRE()]}
            errorText="Araç sahibi ismi giriniz."
            initialValue={loadedItem.owner}
            initialValid={true}
            onInput={inputHandler}
          />

          <Input
            id="driver"
            element="input"
            type="text"
            label="Sürücü"
            validators={[VALIDATOR_NONE()]}
            errorText="Sürücü ismi giriniz."
            initialValue={loadedItem.driver}
            initialValid={true}
            onInput={inputHandler}
          />

          <Input
            id="district"
            element="input"
            type="text"
            label="Güzergah Bölgesi"
            validators={[VALIDATOR_NONE()]}
            errorText="Güzergah bölgesi giriniz."
            initialValue={loadedItem.district}
            initialValid={true}
            onInput={inputHandler}
          />

          <Input
            id="hours"
            element="input"
            type="text"
            label="Servis Saatleri"
            validators={[VALIDATOR_NONE()]}
            errorText="Servis saatlerini giriniz."
            initialValue={loadedItem.hours}
            initialValid={true}
            onInput={inputHandler}
          />

          <DatePicker
            id="startDate"
            onInput={inputHandler}
            label="Hizmet Başlangıç Tarihi"
            initialValid={true}
            validators={[VALIDATOR_NONE()]}
            initialValue={loadedItem.startDate.toString()}
            nonrequired={true}
          ></DatePicker>

          <DatePicker
            id="endingDate"
            onInput={inputHandler}
            label="Hizmet Bitiş Tarihi"
            initialValid={true}
            validators={[VALIDATOR_NONE()]}
            initialValue={loadedItem.endingDate.toString()}
            nonrequired={true}
          ></DatePicker>

          <CustomSelect
            options={isOfficial}
            id="hostess"
            onInput={inputHandler}
            label="Araçta hostes var mı?"
            initialValid={true}
            validators={[VALIDATOR_NONE()]}
            initialValue={isOfficial.find((item) => item.value.toString() === loadedItem.hostess.toString())}
          ></CustomSelect>

          <CustomSelect
            options={isOfficial}
            id="weekend"
            onInput={inputHandler}
            label="Hafta sonu çalışıyor mu?"
            initialValid={true}
            validators={[VALIDATOR_NONE()]}
            initialValue={isOfficial.find((item) => item.value.toString() === loadedItem.weekend.toString())}
          ></CustomSelect>

          <Input
            id="description"
            element="textarea"
            type="text"
            label="Notlar (Araca ait ek bilgileri burada tutabilirsiniz)"
            validators={[VALIDATOR_NONE()]}
            errorText="Servis saatlerini giriniz."
            initialValue={loadedItem.description}
            initialValid={true}
            onInput={inputHandler}
          />

          <Input
            id="amount"
            element="input"
            type="text"
            label="Toplam Ücret"
            validators={[VALIDATOR_REQUIRE()]}
            errorText="Hizmet bedelinin standart ücretini giriniz."
            initialValue={loadedItem.amount}
            initialValid={true}
            onInput={inputHandler}
          />

          <div className="button-container">
            <Button type="submit" disabled={!formState.isValid}>
              Güncelle
            </Button>

            <Button type="button" danger onClick={showDeleteWarningHandler}>
              SİL
            </Button>
          </div>
        </form>
      )}
    </React.Fragment>
  );
};

export default VehiclePaymentItem;
